import { wait, waitForEmitterEvent } from './machine/helpers';
import { GameState, gameStates } from './machine/state-types';
import { get } from 'svelte/store';
import { gameResult, gameRoundInfo, unformattedBalance } from '../store';
import { playAudio } from '../utils/audio';
import { assert, getBonusTypeFromColor, getNormalizeNumberWithDecimals } from '../utils/global';
import { gameInitParams } from '@src/store/misc';
import { EventEmitterInstance } from '../utils/event-emitter';
import { updateHistoryLine } from '../store/game-history';

const winTypeToAudioMap = {
    DEFAULT: 'audio_default_win',
    BIG: 'audio_big_win',
    SUPER: 'audio_super_win',
    EPIC: 'audio_epic_win',
    MEGA: 'audio_mega_win'
};

export const state: GameState = {
    name: gameStates.bigWin,
    onEnter: async setState => {
        const roundInfo = get(gameRoundInfo);
        const { exponent, subunits } = get(gameInitParams).currency_attributes;
        const { win_amount, win_type } = roundInfo?.resp;
        if (!win_amount) assert('win amount missing in round data');
        const normalized = getNormalizeNumberWithDecimals(win_amount, exponent, subunits);
        gameResult.set({
            winAmount: normalized,
            type: win_type
        });

        const audioKey = winTypeToAudioMap[roundInfo.resp.win_type];
        if (!audioKey) assert('unknown winType in bigWin');

        playAudio(audioKey);

        //TODO fix bug - bigwin container on top of controls
        // allowToSkip.set(true);
        //Ждем окончания анимации бигвина или нажатия skip
        await Promise.race([waitForEmitterEvent('big-win-finished'), waitForEmitterEvent('skip-game')]);
        // allowToSkip.set(false);
        await wait();

        updateHistoryLine({
            win: roundInfo?.resp?.win,
            multiplier: getBonusTypeFromColor(roundInfo?.resp?.color) && roundInfo?.resp?.multiplier,
            bonus_game_type: roundInfo?.resp?.bonus_game,
            color: roundInfo?.resp?.color
        });
        unformattedBalance.set(roundInfo.balance);
        EventEmitterInstance.emit('analytics-game-finished', true, win_amount);

        setState(gameStates.game);
    },
    onExit: () => {}
};
